import gql from 'graphql-tag';

export const SAVED_SEARCH_AND_ALERTS_FRAGMENT = gql`
    fragment SAVED_SEARCH_AND_ALERTS_FRAGMENT on SavedSearchAndAlerts {
        uri
        currentFrequency {
            i18NLabelKey
            value
        }
    }
`;
